import { useNavigate } from 'react-router-dom';

import { signOut } from 'api/sessionApi';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { userInfoState } from 'recoil/user/atom';

import HeaderInfo from './HeaderInfo';

function Header() {
  // const userInfo = useRecoilValue(userInfoState);
  const resetUserInfo = useResetRecoilState(userInfoState);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useRecoilState(userInfoState);
  const { factoryCode } = useRecoilValue(userInfoState);

  const handleSignOut = async () => {
    await signOut();
    resetUserInfo();
    sessionStorage.clear();

    navigate('/sign-in');
  };

  const onChangeFactoryCode = (value: string) => {
    setUserInfo((prev) => ({ ...userInfo, factoryCode: value }));
  };
  return (
    <header id={'header-wrap'}>
      <HeaderInfo
        name={userInfo.name}
        onClick={handleSignOut}
        onChange={onChangeFactoryCode}
        factoryCode={factoryCode}
      />
    </header>
  );
}

export default Header;
